import React from 'react';
import { Styles } from '../../../../config/design/styles';
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../components/AppAnimate";
import WalletHistory from "./WalletHistory";
import { translate } from "../../../../config/lang";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid2";
import {useTranslation} from "react-i18next";

const WalletHistoryPage = ({ classes }) => {
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('manageUserWallet')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12}>
                    <div style={{
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"flex-end"
                    }}>
                        <BreadCrumbs
                            firstText={t('manageWallets')}
                            firstLink="/panel/manage/wallets/view-all"
                            secondText={t('manageUserWallet')}
                        />
                    </div>
                    <WalletHistory/>
                </Grid>
            </Grid>
        </AppAnimate>
    );
};

export default withStyles(Styles)(WalletHistoryPage);
